import {
  mapGetters
} from "vuex";

export default {
  metaInfo() {
    return {
      title: this._METAINFOTITLE, // 设置页面title
      meta: this._METAINFOMETA,
    };
  },
  created() {
    console.log(this._METAINFOTITLE);
    console.log(this._METAINFOMETA);
  },
  computed: {
    ...mapGetters(["getMenuRouter", "getGlobalmMetaInfo"]),
    _CURRENTMENU() {
      return (
        this.getMenuRouter.filter((item) =>
          item.url.includes(this.$route.name)
        )[0] || {
          name: "",
          keywords: "",
          description: ""
        }
      );
    },
    _METAINFOTITLE() {
      return this._CURRENTMENU.name + "-" + this.getGlobalmMetaInfo.name;
    },
    _METAINFOMETA() {
      return [{
          name: "keywords",
          content: this._CURRENTMENU.keywords || "1",
        },
        {
          name: "description",
          content: this._CURRENTMENU.description || "2",
        },
      ];
    },
  },
};